import { render } from "./LoveContent.vue?vue&type=template&id=7fbac4f4&scoped=true&ts=true"
import script from "./LoveContent.vue?vue&type=script&lang=ts"
export * from "./LoveContent.vue?vue&type=script&lang=ts"

import "./LoveContent.vue?vue&type=style&index=0&id=7fbac4f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fbac4f4"]])

export default __exports__